import {DocumentContactDto} from "../document-contact.dto";
import {isDefined} from "../../../libs/utils/epic.utils";

export class SheetDto {

  public id!: string;
  public title!: string;
  public content!: string;
  public lastEdit!: Date;
  public contact!: DocumentContactDto;

  constructor(init?: Partial<SheetDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.lastEdit)) {
      this.lastEdit = new Date(init?.lastEdit);
    }
    if (isDefined(init?.contact)) {
      this.contact = new DocumentContactDto(init.contact);
    } else {
      this.contact = new DocumentContactDto();
    }
  }
}
